/**
 * `BaseMaterial3D::get_material_for_2d` (`scene/resources/material.cpp:3021`) in three's terms.
 * Sprite3D and Label3D both build their material there, so the decisions it makes are one module
 * here: the blend and opaque prepass of each pass, the shadow membership, the side and the sampler.
 */
import * as THREE from 'three';
import { alphaCutSurface, joinsShadowPass } from './godotAlphaCut';
import { cutBlends, cutOpaquePrepasses } from './materials/fadeVariants';
import { godotTextureFilterState } from '../resources/textures/godotTextureFilter';
export function materialFor2d(input) {
    const cut = alphaCutSurface({
        mode: input.alphaCut,
        scissorThreshold: input.alphaScissorThreshold,
        transparentFlag: input.transparentFlag,
        antialiasing: { mode: input.alphaAntialiasingMode, edge: input.alphaAntialiasingEdge },
    });
    const depthTest = !input.noDepthTest;
    const blends = cutBlends(cut, depthTest);
    const prepasses = cutOpaquePrepasses(cut, depthTest);
    const { antialiasing } = cut;
    const { alphaHashScale } = input;
    return {
        blends: {
            unfaded: { ...blends.unfaded, alphaHashScale, antialiasing, opaquePrepass: prepasses.unfaded },
            alphaPass: { ...blends.alphaPass, alphaHashScale, antialiasing, opaquePrepass: prepasses.alphaPass },
        },
        joinsShadowPass: joinsShadowPass(cut, depthTest),
        side: input.doubleSided === false ? THREE.FrontSide : THREE.DoubleSide,
        depthTest,
        textureFilter: godotTextureFilterState(input.textureFilter, input.anisotropicFilteringLevel),
    };
}
//# sourceMappingURL=materialFor2d.js.map